// constants are separate for FastRefresh to work properly

export const MAX_SLOTS_TO_SHOW = 7;
